import ProductTypeTabs from './ProductTypetabs';

export default function DoctorHome() {
  return <ProductTypeTabs />;
}
